// extracted by mini-css-extract-plugin
export default {"container":"fullscreen_container__vEF5U","icon":"fullscreen_icon__1eiFd"};